import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'

// Two-column panel layout (used by Scheduling and Receptors show pages)
export const ShowPageDetailsPanel = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  margin-bottom: 32px;
`

export const ShowPageDetailsPanelLeft = styled.div`
  flex: 1;
  padding: 5px 24px 20px 0;
  display: flex;
  flex-direction: column;
`

export const ShowPageDetailsPanelRight = styled.div`
  flex: 1;
  padding: 16px 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
`

// Horizontal metadata strip layout (used by Request show page)
export const ShowPageMetadataStrip = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 24px;
  padding: 10px 0;
  margin-bottom: 8px;
  border-bottom: 1px solid ${palette.neutral[100]};
`

// Inline label + value pair (label left, value right)
export const ShowPageMetadataItem = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
`

export const ShowPageMetadataStripItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 80px;
`

export const ShowPageMetadataStripLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${palette.neutral[400]};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`
